
/**
 * Users API
 */
export default class Users {
  constructor(axios) {
    this.$axios = axios
  }

  Login(email, password) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'post',
        url: '/login',
        data: { email, password }
      })
        .then(({ data }) => {
          resolve(data.token)
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  LoginCheck() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/login',
      })
        .then(() => {
          resolve()
        })
        .catch(() => {
          reject()
        })
    })
  }

  ForgotPassword(email) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'put',
        url: '/login/forgot',
        data: { email }
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  VerifyPasswordResetToken(token) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/login/reset',
        params: { token }
      })
        .then(({ data }) => {
          resolve(data.valid)
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  ResetPassword(token, password, password2) {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'put',
        url: '/login/reset',
        data: { token, password, password2 }
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }
}
